module.exports = __webpack_public_path__ + "static/media/Safari.b9b7894d.svg";